"use client"

import { useAtomValue } from "jotai"
import { useParams } from "next/navigation"
import React from "react"
import { useTranslation } from "react-i18next"

import withErrorBoundary from "@/shared-module/common/utils/withErrorBoundary"
import { LoadingRegion, ErrorNotice } from "@/shared-module/components"
import { currentPageDataAtom, viewStatusAtom } from "@/state/course-material/selectors"

import type { BlockRendererProps } from "../.."
import PagesInChapter from "./PagesInChapter"

const PagesInChapterBlock: React.FC<React.PropsWithChildren<BlockRendererProps<unknown>>> = () => {
  const { t } = useTranslation()
  const viewStatus = useAtomValue(viewStatusAtom)
  const pageData = useAtomValue(currentPageDataAtom)
  const params = useParams<{ organizationSlug: string; courseSlug: string }>()
  const courseSlug = params?.courseSlug
  const organizationSlug = params?.organizationSlug

  if (viewStatus !== "ready") {
    return <LoadingRegion />
  }
  const chapterId = pageData?.chapter_id

  if (!chapterId) {
    return <ErrorNotice error={t("error-page-does-not-belong-to-chapter")} />
  }

  if (!courseSlug || !organizationSlug) {
    return <LoadingRegion />
  }

  return (
    <div>
      <PagesInChapter
        chapterId={chapterId}
        organizationSlug={organizationSlug}
        courseSlug={courseSlug}
      />
    </div>
  )
}

export default withErrorBoundary(PagesInChapterBlock)
